import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import {
  ELandLineListActions,
  GetLandLineList,
  GetLandLineListFailure,
  GetLandLineListSuccess
} from '../actions/land-line-list.actions';
import { LandLineListInterface } from '../../models/land-line-list.interface';
import { LandLinesService } from '../../services/land-lines.service';

@Injectable()
export class LandLineListEffects extends AbstractEffects {

    constructor(
        private actions: Actions,
        private landLinesService: LandLinesService,
        public override store: Store<any>
    ) {
        super(store);
    }

    getLandLineList = createEffect(() => this.actions.pipe(
        ofType<GetLandLineList>(ELandLineListActions.GetLandLineList),
        switchMap(() => this.landLinesService.getLandLineList()),
        switchMap((response: Array<LandLineListInterface>) => of(new GetLandLineListSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetLandLineList());
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetLandLineListFailure());
            }
            return throwError(error);
        })
    ));
}
